import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";

export class WithdrawContractCommand extends BasicCommand<WithdrawContractCommand> {
    readonly virkeskopskontraktSigneringId: number;

    static readonly $type = "WithdrawContractCommand";

    static readonly $groupKey = "KontraktUtskrift";

    get primaryKey(): IPrimaryKey<WithdrawContractCommand> {
        return {
            virkeskopskontraktSigneringId: this.virkeskopskontraktSigneringId
        };
    }

    constructor(virkeskopskontraktSigneringId: number) {
        super(WithdrawContractCommand.$type, WithdrawContractCommand.$groupKey, CommandType.Replace);
        this.virkeskopskontraktSigneringId = virkeskopskontraktSigneringId;
    }
}
